module.exports = require("adbkit");


//////////////////
// WEBPACK FOOTER
// external "adbkit"
// module id = 194
// module chunks = 0